import PropTypes from 'prop-types';

export const children = PropTypes.node;
export const flag = PropTypes.bool;
export const handler = PropTypes.func;
export const url = PropTypes.string;
export const pristine = PropTypes.bool;
export const submitting = PropTypes.bool;
export const valid = PropTypes.bool;
export const string = PropTypes.string;
export const number = PropTypes.number;
export const total = PropTypes.shape({
  priceWithoutTaxes: PropTypes.number,
  taxAmount: PropTypes.number,
  priceWithTaxes: PropTypes.number,
});

export const service = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number,
});
export const services = PropTypes.arrayOf(service);

export const discount = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.number,
  quantity: PropTypes.number,
});
export const discounts = PropTypes.arrayOf(discount);

export const barber = PropTypes.shape({
  id: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
});
export const barbers = PropTypes.arrayOf(barber);
